import { useQuery } from '@tanstack/react-query';

import publicESignFetch from '@/adapters/publicESignFetch';

import { parseCompletedDocumentDownloadPreparation } from './completedDocumentDownloadValidation';

export const PUBLIC_COMPLETED_DOCUMENT_DOWNLOAD_QUERY_KEY =
  'public-completed-document-download';

export function buildCompletedDocumentDownloadApiPath(
  token: string | undefined,
  pathSuffix?: string
) {
  const basePath = '/public/completed-documents';
  const tokenPath = token
    ? `${basePath}/${encodeURIComponent(token)}`
    : basePath;
  if (!pathSuffix) {
    return tokenPath;
  }

  const encodedSuffix = pathSuffix.split('/').map(encodeURIComponent).join('/');
  return `${tokenPath}/${encodedSuffix}`;
}

export function useCompletedDocumentDownload(
  token: string | undefined,
  pathSuffix?: string
) {
  const apiPath = buildCompletedDocumentDownloadApiPath(token, pathSuffix);

  return useQuery({
    queryKey: [PUBLIC_COMPLETED_DOCUMENT_DOWNLOAD_QUERY_KEY, token, pathSuffix],
    queryFn: async () => {
      const response = await publicESignFetch.get<unknown>(apiPath, {
        headers: { Accept: 'application/json' },
        searchParams: { format: 'json' }
      });

      return parseCompletedDocumentDownloadPreparation(response);
    },
    enabled: Boolean(token),
    retry: false
  });
}
